var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 22c0 .479-.403.867-.9.867H3.072l4.825 4.652c.351.34.351.888 0 1.227-.351.339-.92.339-1.272 0l-6.36-6.133c-.352-.338-.352-.888 0-1.226l6.36-6.133c.351-.339.92-.339 1.272 0 .326.315.35.81.07 1.15l-.07.077-4.825 4.65 13.03.002c.496 0 .899.388.899.867z",
    transform: "translate(-16 -258) translate(16 243)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.6b8beb54b52734f1d05057ea94f2a459.svg";
export { ForwardRef as ReactComponent };